import React from 'react';
import { Card, Empty } from 'antd';
import styles from './styles/chart-placeholder.module.scss';

const ChartPlaceholder = ({ title }) => (
    <Card className={styles.chartPlaceholder} title={title}>
        <Empty 
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description=""
            className={styles.chartEmpty}
        />
    </Card>
);

export default ChartPlaceholder;
